import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '@constants'
import DownloadAppModal from '@components/common/DownloadAppModal'
import phoneImage from '@assets/images/img_KUDHI.png'

// Composants partagés des pages vitrine (accueil, tarification, à propos, aide…)

export const NAVY = '#002A4E'
export const NAVY_DARK = '#001A33'
export const GOLD = '#FFD700'
export const GOLD_TEXT = '#B8860B'
// Pastille d'icône jaune pleine
export const GOLD_ICON = { background: 'linear-gradient(135deg, #FFE45C 0%, #FFD700 50%, #F5B700 100%)', color: NAVY, boxShadow: '0 8px 20px -8px rgba(245,183,0,0.7)' }

export function useInView(threshold = 0.15) {
  const ref = useRef(null)
  const [inView, setInView] = useState(false)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); observer.disconnect() } },
      { threshold }
    )
    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [threshold])
  return [ref, inView]
}

// Apparition au scroll
export const Reveal = ({ as: Tag = 'div', delay = 0, className = '', style, children, ...rest }) => {
  const [ref, inView] = useInView()
  return (
    <Tag
      ref={ref}
      className={`anim-hidden ${inView ? 'animate-fade-in-up' : ''} ${className}`}
      style={{ animationDelay: `${delay}ms`, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  )
}

export const ICONS = {
  arrow:    'M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3',
  check:    'M4.5 12.75l6 6 9-13.5',
  chevron:  'M19.5 8.25l-7.5 7.5-7.5-7.5',
  phone:    'M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3',
  shield:   'M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z',
  bolt:     'M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z',
  users:    'M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z',
  globe:    'M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418',
  search:   'M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z',
  mail:     'M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75',
  call:     'M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z',
  pin:      'M15 10.5a3 3 0 11-6 0 3 3 0 016 0z M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z',
  user:     'M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z',
  briefcase:'M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0',
  warning:  'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z',
  sparkles: 'M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z',
  heart:    'M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z',
  doc:      'M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z',
  lock:     'M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z',
  card:     'M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z',
  pencil:   'M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10',
  question: 'M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z',
  chat:     'M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z',
  clock:    'M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z',
}

export const Icon = ({ d, className = 'w-6 h-6', strokeWidth = 1.8 }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth={strokeWidth} viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d={d} />
  </svg>
)

// En-tête crème des pages intérieures
export function PageHero({ badge, badgeIcon = 'sparkles', title, highlight, subtitle, children, align = 'center' }) {
  const centered = align === 'center'
  return (
    <section className="relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #FFFCF3 0%, #FFF9E6 35%, #FFFFFF 100%)' }}>
      <div className="absolute inset-0 home-grid-bg-light pointer-events-none" />
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 45% 55% at 50% 45%, rgba(255,215,0,0.45) 0%, rgba(255,215,0,0.12) 55%, transparent 100%)' }} />

      <div className={`relative w-[90%] md:w-[80%] mx-auto pt-16 pb-14 lg:pt-24 ${centered ? 'text-center' : ''}`}>
        {badge && (
          <div className="hero-badge-in inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 backdrop-blur px-4 py-1.5 text-sm font-medium text-slate-700 shadow-sm" style={{ opacity: 0 }}>
            <Icon d={ICONS[badgeIcon]} className="w-4 h-4" />
            {badge}
          </div>
        )}
        <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08]" style={{ color: NAVY }}>
          {title}
          {highlight && (
            <>
              <br />
              <span className="home-highlight px-1" style={{ color: '#C98F00' }}>{highlight}</span>
            </>
          )}
        </h1>
        {subtitle && (
          <p className={`mt-6 text-lg sm:text-xl text-slate-600 max-w-2xl leading-relaxed ${centered ? 'mx-auto' : ''}`}>
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  )
}

export function SectionHeading({ eyebrow, title, text, center = false, className = '' }) {
  return (
    <Reveal className={`${center ? 'text-center mx-auto' : ''} max-w-2xl ${className}`}>
      {eyebrow && <p className="text-sm font-bold uppercase tracking-widest" style={{ color: GOLD_TEXT }}>{eyebrow}</p>}
      <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight" style={{ color: NAVY }}>{title}</h2>
      {text && <p className="mt-4 text-lg text-slate-600">{text}</p>}
    </Reveal>
  )
}

// Bandeau doré pleine largeur de fin de page
export function CtaBand({
  badge = 'Inscription gratuite',
  title = 'Prêt à booster votre visibilité ?',
  text = 'Rejoignez les entrepreneurs qui font confiance à KUDHI pour développer leur activité et atteindre leurs cibles.',
  primary = { to: ROUTES.REGISTER, label: 'Créer mon compte gratuitement' },
  secondary = { to: '/contact', label: 'Nous contacter' },
}) {
  const [downloadOpen, setDownloadOpen] = useState(false)

  return (
    <section
      className="relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #FFE45C 0%, #FFD700 45%, #F5B700 100%)' }}
    >
      <div className="absolute inset-0 home-grid-bg-light pointer-events-none" />
      <div className="absolute -bottom-40 -left-24 w-[420px] h-[420px] rounded-full bg-white/30 blur-3xl pointer-events-none" />
      <div className="absolute top-1/2 right-[18%] -translate-y-1/2 w-[460px] aspect-square rounded-full border border-white/50 pointer-events-none hidden lg:block" />
      <div className="absolute top-1/2 right-[18%] -translate-y-1/2 w-[620px] aspect-square rounded-full border border-dashed border-white/40 pointer-events-none hidden lg:block" />

      <div className="w-[90%] md:w-[80%] mx-auto">
        <Reveal className="grid lg:grid-cols-[1.6fr_1fr] items-center">
          <div className="relative py-16 lg:py-24">
            {badge && (
              <span className="inline-flex items-center gap-2 rounded-full bg-white/60 px-4 py-1.5 text-sm font-semibold" style={{ color: NAVY }}>
                <span className="h-2 w-2 rounded-full" style={{ background: NAVY }} />
                {badge}
              </span>
            )}
            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1]" style={{ color: NAVY }}>
              {title}
            </h2>
            <p className="mt-5 text-lg max-w-lg" style={{ color: 'rgba(0,42,78,0.75)' }}>{text}</p>
            <div className="mt-9 flex flex-col sm:flex-row sm:flex-wrap gap-3">
              <Link
                to={primary.to}
                className="group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-7 py-4 text-base font-bold text-white shadow-lg shadow-black/15 transition-all hover:-translate-y-0.5 hover:shadow-xl"
                style={{ background: NAVY }}
              >
                {primary.label}
                <Icon d={ICONS.arrow} className="w-5 h-5 transition-transform group-hover:translate-x-1" strokeWidth={2.2} />
              </Link>
              {secondary && (
                <Link
                  to={secondary.to}
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-md px-7 py-4 text-base font-semibold bg-white/70 transition-colors hover:bg-white"
                  style={{ color: NAVY }}
                >
                  {secondary.label}
                </Link>
              )}
            </div>
            <button
              type="button"
              onClick={() => setDownloadOpen(true)}
              className="mt-8 inline-flex items-center gap-2 text-sm font-semibold underline-offset-4 hover:underline"
              style={{ color: NAVY }}
            >
              <Icon d={ICONS.phone} className="w-4 h-4" />
              Téléchargez aussi l&apos;application mobile
            </button>
          </div>

          <div className="relative hidden lg:flex justify-center self-end h-full">
            <img
              src={phoneImage}
              alt=""
              className="relative mt-14 -mb-56 h-[720px] max-w-none w-auto object-contain drop-shadow-[0_30px_50px_rgba(0,42,78,0.35)] rotate-[6deg]"
            />
          </div>
        </Reveal>
      </div>

      <DownloadAppModal open={downloadOpen} onClose={() => setDownloadOpen(false)} />
    </section>
  )
}
